import { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem('cuaratech_user');
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem('cuaratech_token');
    if (t && !user) {
      api.get('/auth/me').then(r => {
        setUser(r.data);
        localStorage.setItem('cuaratech_user', JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem('cuaratech_token');
        localStorage.removeItem('cuaratech_user');
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post('/auth/login', { email, password });
      localStorage.setItem('cuaratech_token', r.data.access_token);
      localStorage.setItem('cuaratech_user', JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const register = async (email, password, name) => {
    setLoading(true);
    try {
      const r = await api.post('/auth/register', { email, password, name });
      localStorage.setItem('cuaratech_token', r.data.access_token);
      localStorage.setItem('cuaratech_user', JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem('cuaratech_token');
    localStorage.removeItem('cuaratech_user');
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
